import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadgeDot from "components/MDBadgeDot";
import PieChart from "examples/Charts/PieChart";
import { CategoryDto, SubCategoryDto } from "types";

interface Props {
  userData: {categories: CategoryDto[], subcategories: SubCategoryDto[]}
}

function CategoriesChart({ userData }: Props): JSX.Element {
  const colors = ["#ffe12a", "#f54c5b", "#cb6efe", "#8fdc9c", "#00b9f8", "#ff8445"];

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        <MDTypography variant="h6">Subcategories per Category</MDTypography>
      </MDBox>
      <MDBox mt={3}>
        <Grid container alignItems="center">
          <Grid item xs={7}>
            <PieChart chart={{
              labels:userData.categories.map(category => category.name),
              datasets: {
                label: "Categories",
                backgroundColors: userData.categories.map((category, index) => colors[index]),
                data: userData.categories.map(category => userData.subcategories.filter(subcategory => subcategory.SK === category.PK).length),
              },
            }} height="12.5rem" />
          </Grid>
          <Grid item xs={5}>
            <MDBox pr={1}>
              {userData.categories.map((category, index) =>
                <MDBox key={category.PK} mb={1}>
                  <MDBadgeDot color={colors[index]} size="sm" badgeContent={category.name} notFlex complement={`${userData.subcategories.filter(subcategory => subcategory.SK === category.PK).length} subcategories`} />
                </MDBox>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default CategoriesChart;
